import { render, staticRenderFns } from "./importRoulette.vue?vue&type=template&id=471ab8ac&"
import script from "./importRoulette.vue?vue&type=script&lang=js&"
export * from "./importRoulette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports